/* SmoothEnds — interacciones propias (prefijo se-) · v2 arrastre táctil */
(function () {
  // Cada sección incluye este archivo: ejecutarlo solo una vez por página
  if (window.__seScriptsLoaded) return;
  window.__seScriptsLoaded = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.se-reveal:not(.se-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('se-visible'); });
      return;
    }
    // Lo que ya está en pantalla al cargar se muestra sin esperar al observador
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('se-visible');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('se-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (reduce) return;
    var items = document.querySelectorAll('[data-se-parallax]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      items.forEach(function (img) {
        if (window.innerWidth < 750) { img.style.transform = ''; return; }
        var strength = parseFloat(img.getAttribute('data-se-parallax')) || 0;
        var rect = img.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        img.style.transform = 'translate3d(0,' + (-rect.top * strength / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initCompare() {
    document.querySelectorAll('.se-ba__compare').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var range = box.querySelector('.se-ba__range');
      if (!range) return;
      var set = function () { box.style.setProperty('--pos', range.value + '%'); };
      // Teclado / lectores de pantalla: el control nativo sigue funcionando
      range.addEventListener('input', function () { set(); box.classList.add('is-touched'); });

      // Dedo o ratón: toda la imagen responde y el producto sigue al dedo
      var active = null, startX = 0, startY = 0, decided = false;
      function moveTo(clientX) {
        var r = box.getBoundingClientRect();
        var pct = Math.max(0, Math.min(100, (clientX - r.left) / r.width * 100));
        range.value = pct;
        set();
        box.classList.add('is-touched');
      }
      box.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        active = e.pointerId; startX = e.clientX; startY = e.clientY;
        decided = e.pointerType === 'mouse';
        if (decided) { box.classList.add('is-dragging'); box.setPointerCapture(e.pointerId); moveTo(e.clientX); e.preventDefault(); }
      });
      box.addEventListener('pointermove', function (e) {
        if (e.pointerId !== active) return;
        if (!decided) {
          var dx = Math.abs(e.clientX - startX), dy = Math.abs(e.clientY - startY);
          if (dx < 6 && dy < 6) return;
          if (dy > dx) { active = null; return; } // gesto vertical: dejar que la página haga scroll
          decided = true;
          box.classList.add('is-dragging');
          try { box.setPointerCapture(e.pointerId); } catch (err) {}
        }
        moveTo(e.clientX);
      });
      function end(e) {
        if (e.pointerId !== active) return;
        if (!decided && e.type === 'pointerup') moveTo(e.clientX); // un toque salta a esa posición
        active = null; decided = false;
        box.classList.remove('is-dragging');
      }
      box.addEventListener('pointerup', end);
      box.addEventListener('pointercancel', end);
      set();
    });
  }

  function initProduct() {
    document.querySelectorAll('[data-se-pdp]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var dataEl = root.querySelector('[data-se-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
      var idInput = root.querySelector('input[name="id"]');
      var priceNow = root.querySelectorAll('[data-se-price]');
      var priceOld = root.querySelector('[data-se-compare]');
      var saveEl = root.querySelector('[data-se-save]');
      var buttons = root.querySelectorAll('[data-se-add]');
      var soldText = root.getAttribute('data-sold-text');
      var addText = root.getAttribute('data-add-text');
      var mainImg = root.querySelector('[data-se-main]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('.se-pdp__thumb'));

      function money(cents) {
        var v = (cents / 100).toFixed(2);
        var withComma = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, withComma)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
      }

      function showImage(i) {
        var t = thumbs[i];
        if (!t || !mainImg) return;
        mainImg.src = t.getAttribute('data-src');
        mainImg.srcset = t.getAttribute('data-srcset') || '';
        mainImg.alt = t.getAttribute('data-alt') || '';
        thumbs.forEach(function (x, j) { x.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        root.setAttribute('data-index', i);
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showImage(i); }); });
      root.querySelectorAll('[data-se-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!thumbs.length) return;
          var cur = parseInt(root.getAttribute('data-index') || '0', 10);
          var n = (cur + parseInt(btn.getAttribute('data-se-step'), 10) + thumbs.length) % thumbs.length;
          showImage(n);
        });
      });

      function current() {
        var selected = [];
        root.querySelectorAll('.se-opt:not(.se-opt--mix)').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          if (c) selected.push(c.value === '__mix__' ? singleBundleValue() : c.value);
          var label = fs.querySelector('[data-se-selected]');
          if (label && c) label.textContent = c.value;
        });
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
      }

      // ---- Mix & match del pack ----
      var mixFs = root.querySelector('[data-se-mix]');
      var mixOn = root.getAttribute('data-mix') === '1' && !!mixFs;
      var mixKey = root.getAttribute('data-mix-keyword') || '2-Pack';
      var colorFs = root.querySelector('.se-opt[data-option-name="' + (root.getAttribute('data-color-name') || 'Color') + '"]');
      var bundleFs = root.querySelector('.se-opt[data-option-name="' + (root.getAttribute('data-bundle-name') || 'Bundle') + '"]');
      var colorLegend = colorFs && colorFs.querySelector('[data-se-legend]');
      var colorLegendOrig = colorLegend ? colorLegend.textContent : '';
      function packSelected() {
        if (!mixOn || !bundleFs) return false;
        var c = bundleFs.querySelector('input:checked');
        return !!c && c.value === '__mix__';
      }
      function singleBundleValue() {
        var bi = bundleFs ? parseInt(bundleFs.getAttribute('data-option-index'), 10) : 0;
        var s = variants.find(function (v) { return v.options[bi].indexOf(mixKey) === -1; });
        return s ? s.options[bi] : '';
      }
      function singleVariantFor(color) {
        if (!bundleFs || !colorFs) return null;
        var bi = parseInt(bundleFs.getAttribute('data-option-index'), 10), ci = parseInt(colorFs.getAttribute('data-option-index'), 10);
        return variants.find(function (v) { return v.options[bi].indexOf(mixKey) === -1 && v.options[ci] === color; });
      }
      function cartItems() {
        var v = current();
        if (!packSelected()) return [{ id: v ? v.id : parseInt(idInput.value, 10), quantity: 1 }];
        var c1 = colorFs.querySelector('input:checked').value;
        var c2el = mixFs.querySelector('input:checked');
        var c2 = c2el ? c2el.value : c1;
        var v1 = singleVariantFor(c1), v2 = singleVariantFor(c2);
        if (!v1 || !v2) return [{ id: parseInt(idInput.value, 10), quantity: 1 }];
        var props = {}; props[root.getAttribute('data-mix-property') || 'Bundle'] = c1 + ' + ' + c2;
        if (v1.id === v2.id) return [{ id: v1.id, quantity: 2, properties: props }];
        return [{ id: v1.id, quantity: 1, properties: props }, { id: v2.id, quantity: 1, properties: props }];
      }
      function updateMix() {
        if (!mixOn) return;
        var on = packSelected();
        mixFs.hidden = !on;
        if (colorLegend) colorLegend.textContent = on ? (root.getAttribute('data-mix-label1') || 'Trimmer 1') : colorLegendOrig;
        var c2 = mixFs.querySelector('input:checked'), lab = mixFs.querySelector('[data-se-selected2]');
        if (c2 && lab) lab.textContent = c2.value;
      }

      function update() {
        updateMix();
        var v = current();
        buttons.forEach(function (b) {
          b.disabled = !v || !v.available;
          var span = b.querySelector('span') || b;
          span.textContent = !v ? soldText : (v.available ? addText : soldText);
        });
        if (!v) return;
        idInput.value = v.id;
        priceNow.forEach(function (p) { p.textContent = money(v.price); });
        if (packSelected()) {
          var mixInput = bundleFs.querySelector('input[value="__mix__"]');
          var mixPrice = parseInt(mixInput.getAttribute('data-mix-price'), 10);
          priceNow.forEach(function (p) { p.textContent = money(mixPrice); });
          var c2el = mixFs.querySelector('input:checked');
          var v2 = singleVariantFor(c2el ? c2el.value : '');
          var ok = v.available && v2 && v2.available;
          buttons.forEach(function (b) { b.disabled = !ok; var span = b.querySelector('span') || b; span.textContent = ok ? addText : soldText; });
        }
        if (priceOld) {
          var has = v.compare_at_price && v.compare_at_price > v.price;
          priceOld.textContent = has ? money(v.compare_at_price) : '';
          priceOld.hidden = !has;
          if (saveEl) {
            saveEl.hidden = !has;
            if (has) saveEl.textContent = saveEl.getAttribute('data-label').replace('[percent]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%');
          }
        }
        if (v.featured_media_id) {
          var idx = thumbs.findIndex(function (t) { return t.getAttribute('data-media-id') == v.featured_media_id; });
          if (idx > -1) showImage(idx);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.querySelectorAll('.se-opt input').forEach(function (i) { i.addEventListener('change', update); });
      update();

      var form = root.querySelector('form[action*="/cart/add"]');
      var errorEl = root.querySelector('.se-pdp__error');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          var body = { items: cartItems() };
          if (cart && cart.getSectionsToRender) {
            body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
            body.sections_url = window.location.pathname;
          }
          buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) { if (errorEl) errorEl.textContent = res.description || res.message; return; }
            if (errorEl) errorEl.textContent = '';
            if (cart && cart.renderContents) {
              var item = res.items ? res.items[0] : res;
              item.sections = res.sections;
              cart.renderContents(item);
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            } else {
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            }
          }).catch(function () { form.submit(); })
            .finally(function () {
              buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
              update();
            });
        });
      }

      var sticky = document.querySelector('[data-se-sticky]');
      var mainBtn = root.querySelector('.se-pdp__buy');
      if (sticky && mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(mainBtn);
        var sb = sticky.querySelector('[data-se-add]');
        if (sb) sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      }
    });
  }

  function initReviews() {
    document.querySelectorAll('[data-se-reviews]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var track = root.querySelector('.se-rv__track');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.se-rv__card'));
      var arrows = root.querySelectorAll('.se-rv__arrow');
      var bar = root.querySelector('.se-rv__progress span');

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var ratio = max > 0 ? track.scrollLeft / max : 1;
        if (bar) {
          var visible = max > 0 ? track.clientWidth / track.scrollWidth : 1;
          bar.style.width = Math.max(visible * 100, 8) + '%';
          bar.style.transform = 'translateX(' + (ratio * (1 / Math.max(visible, 0.08) - 1) * 100) + '%)';
        }
        arrows.forEach(function (a) {
          var dir = parseInt(a.getAttribute('data-dir'), 10);
          a.disabled = max <= 2 || (dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2);
        });
      }
      function step() {
        var first = cards.find(function (c) { return !c.classList.contains('is-hidden'); });
        return first ? first.getBoundingClientRect().width + 20 : track.clientWidth;
      }
      arrows.forEach(function (a) {
        a.addEventListener('click', function () {
          track.scrollBy({ left: step() * parseInt(a.getAttribute('data-dir'), 10), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          track.scrollBy({ left: e.key === 'ArrowRight' ? step() : -step(), behavior: 'smooth' });
        }
      });

      // Arrastrar con el ratón (en móvil el deslizamiento es nativo)
      var down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
        if (moved) track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        if (moved) {
          track.classList.remove('is-dragging');
          var s = step();
          track.scrollTo({ left: Math.round(track.scrollLeft / s) * s, behavior: 'smooth' });
        }
      });

      // Leer más / leer menos
      cards.forEach(function (card) {
        var q = card.querySelector('[data-se-clamp]');
        var btn = card.querySelector('.se-rv__more');
        if (!q || !btn) return;
        q.classList.add('is-clamped');
        if (q.scrollHeight > q.clientHeight + 4) {
          btn.hidden = false;
          btn.addEventListener('click', function () {
            var open = q.classList.toggle('is-clamped') === false;
            btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
            btn.setAttribute('aria-expanded', open);
            update();
          });
        } else {
          q.classList.remove('is-clamped');
        }
      });

      // Filtros por tema
      root.querySelectorAll('.se-rv__chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var f = chip.getAttribute('data-filter');
          root.querySelectorAll('.se-rv__chip').forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', on);
          });
          cards.forEach(function (card) {
            var tags = (card.getAttribute('data-tags') || '').split(' ');
            var show = f === 'all' || tags.indexOf(f) > -1;
            card.classList.toggle('is-hidden', !show);
            card.classList.remove('is-entering');
            if (show && !reduce) { void card.offsetWidth; card.classList.add('is-entering'); }
          });
          track.scrollTo({ left: 0, behavior: 'auto' });
          update();
        });
      });
      update();
    });
  }

  function initTilt() {
    if (reduce) return;
    document.querySelectorAll('[data-se-tilt]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var max = parseFloat(el.getAttribute('data-se-tilt')) || 0;
      if (!max) return;
      var zone = el.closest('.se-hero') || el.parentElement;
      var raf = null;
      zone.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = zone.getBoundingClientRect();
        var dx = (e.clientX - r.left) / r.width * 2 - 1, dy = (e.clientY - r.top) / r.height * 2 - 1;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          el.style.setProperty('--ry', (dx * max).toFixed(2) + 'deg');
          el.style.setProperty('--rx', (-dy * max * 0.6).toFixed(2) + 'deg');
        });
      });
      zone.addEventListener('pointerleave', function () { el.style.setProperty('--ry', '0deg'); el.style.setProperty('--rx', '0deg'); });
      // En móvil: un leve giro según el scroll
      if (window.matchMedia('(hover: none)').matches) {
        window.addEventListener('scroll', function () {
          var r = zone.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) return;
          var t = Math.max(-1, Math.min(1, -r.top / r.height * 2));
          el.style.setProperty('--ry', (t * max).toFixed(2) + 'deg');
        }, { passive: true });
      }
    });
  }

  function initArc() {
    document.querySelectorAll('[data-se-arc]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var dialog = root.querySelector('.se-arc__dialog');
      var panels = Array.prototype.slice.call(root.querySelectorAll('.se-arc__panel'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.se-arc__navdot'));
      if (!dialog || !panels.length) return;
      var current = 0;
      function show(i) {
        current = (i + panels.length) % panels.length;
        panels.forEach(function (p, k) {
          var on = k === current;
          p.hidden = !on;
          p.classList.remove('is-entering');
          if (on && !reduce) { void p.offsetWidth; p.classList.add('is-entering'); }
        });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === current); d.setAttribute('aria-current', k === current); });
      }
      function open(i) {
        show(i);
        if (typeof dialog.showModal === 'function') { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
        document.documentElement.style.overflow = 'hidden';
      }
      function close() {
        if (typeof dialog.close === 'function') { dialog.close(); } else { dialog.removeAttribute('open'); }
      }
      dialog.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
      root.querySelectorAll('.se-arc__item').forEach(function (b) {
        b.addEventListener('click', function () { open(parseInt(b.getAttribute('data-index'), 10)); });
      });
      root.querySelectorAll('[data-arc-step]').forEach(function (b) {
        b.addEventListener('click', function () { show(current + parseInt(b.getAttribute('data-arc-step'), 10)); });
      });
      dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-arc-go'), 10)); }); });
      root.querySelector('[data-arc-close]').addEventListener('click', close);
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') show(current + 1);
        if (e.key === 'ArrowLeft') show(current - 1);
      });
      // Deslizar con el dedo dentro de la vista de cerca
      var sx = null;
      dialog.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      dialog.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 50) show(current + (dx < 0 ? 1 : -1));
      });
      // Pista: en pantallas táctiles, un producto se levanta un momento para invitar a tocar
      var stage = root.querySelector('.se-arc__stage');
      var items = root.querySelectorAll('.se-arc__item');
      if (!reduce && window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window && items.length) {
        var done = false;
        new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting || done) return;
          done = true;
          var k = 0;
          var t = setInterval(function () {
            items.forEach(function (it) { it.classList.remove('is-hint'); });
            if (k >= items.length) { clearInterval(t); return; }
            items[k].classList.add('is-hint'); k++;
          }, 650);
          stage.addEventListener('pointerdown', function () { clearInterval(t); items.forEach(function (it) { it.classList.remove('is-hint'); }); }, { once: true });
        }, { threshold: 0.6 }).observe(stage);
      }
    });
  }

  function initGifts() {
    document.querySelectorAll('[data-se-gift]').forEach(function (card) {
      if (card.dataset.ready) return;
      card.dataset.ready = '1';
      var imgs = card.querySelectorAll('.se-gift-card__img');
      var chips = card.querySelectorAll('.se-gift-card__chip');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var i = chip.getAttribute('data-i');
          chips.forEach(function (c) { var on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', on); });
          imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-i') === i); });
        });
      });
    });
  }

  function initColors() {
    document.querySelectorAll('[data-se-colors]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var btns = Array.prototype.slice.call(root.querySelectorAll('.se-col__swatch'));
      if (!btns.length) return;
      var current = 0, timer = null;
      var secs = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
      function show(i) {
        current = i;
        ['.se-col__slide', '.se-col__detail', '.se-col__swatch'].forEach(function (sel) {
          root.querySelectorAll(sel).forEach(function (el) {
            var on = parseInt(el.getAttribute('data-index'), 10) === i;
            el.classList.toggle('is-active', on);
            if (el.classList.contains('se-col__swatch')) el.setAttribute('aria-pressed', on);
          });
        });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      btns.forEach(function (b) {
        b.addEventListener('click', function () { stop(); show(parseInt(b.getAttribute('data-index'), 10)); });
      });
      if (secs > 0 && !reduce && btns.length > 1 && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting && !timer && !root.dataset.stopped) {
            timer = setInterval(function () { show((current + 1) % btns.length); }, secs * 1000);
          } else if (!entries[0].isIntersecting) { stop(); }
        }, { threshold: 0.4 }).observe(root);
        root.addEventListener('pointerdown', function () { root.dataset.stopped = '1'; stop(); });
      }
    });
  }

  function init() { initReveal(); initParallax(); initCompare(); initProduct(); initReviews(); initColors(); initTilt(); initArc(); initGifts(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initReveal(); initCompare(); initProduct(); initReviews(); initColors(); initTilt(); initArc(); initGifts(); });
})();
